import React from 'react';
import PropTypes from 'prop-types';
import Numeral from 'numeral';
import moment from 'moment';
import _ from 'lodash';

const PropertyInfo = ({ ...props }) => {
  PropertyInfo.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    userprofile: PropTypes.object,
    addPropertyClickHandler: PropTypes.func.isRequired
  };

  let formattedCityState = '';
  const { city = '', stateOrProvince = '', postalCode = '', address1 = '' } = _.get(props, 'property.address', {});
  if (city) {
    formattedCityState = `${formattedCityState ? `${formattedCityState}, ` : ''}${city}`;
  }

  if (stateOrProvince) {
    formattedCityState = `${formattedCityState ? `${formattedCityState}, ` : ''}${stateOrProvince}`;
  }

  if (postalCode) {
    formattedCityState = `${formattedCityState ? `${formattedCityState} ` : ''}${postalCode}`;
  }

  return (
    <React.Fragment>
      <div>
        {
          props.property.imageUrl
            ? <div >
              <img src={props.property.imageUrl} style={{ width: '100%' }} />
            </div>
            : null
        }
        <div>
          {address1 && <div>{address1}</div>}
          {formattedCityState && <div>{formattedCityState}</div>}
          <div>
            {`$${Numeral(props.property.price).format('0,0')}`}
            {props.property.listingStatus ? ' - ' : ''}
            <strong>
              {props.property.listingStatus || ''}
            </strong>
          </div>

          <div>{`${props.property.bedrooms ? `${props.property.bedrooms} Bd ` : ''}${props.property.baths ? `${props.property.baths} Ba ` : ''}${props.property.buildingSize || ''} ${props.property.livingAreaUnits || ''}`}</div>
          <div>{`${props.property.listingDate ? `Listed: ${moment(props.property.listingDate).format('MM/DD/YY')}` : ''}`}</div>
          <div>{`${props.property.listingExpirationDate ? `Expr: ${moment(props.property.listingExpirationDate).format('MM/DD/YY')}` : ''}`}</div>

          <div>
            <strong>{`${props.property.listingOfficeName ? `Courtesy of ${props.property.listingOfficeName}` : ''}`}</strong>
            <div className='display-mls-block'>
              <span className='text-primary display-mlsId'>{`MLS# ${props.property.mlsListingId}`}</span>
              <a onClick={() => props.addPropertyClickHandler(props.opportunity, 'Update Property', props.property.mlsListingId, props.property.address.stateOrProvince)}>
                <span className='icon icon-tasks text-primary' />
              </a>
            </div>
            <div>
              <strong>{`${props.property.listingAgentName ? ` Agent: ${props.property.listingAgentName}` : ''}`}</strong>
            </div>
            <div>
              {props.property.listingAgentPhoneNumber}
            </div>
          </div>

        </div>
        {
          props.property.propertyInfoSource === 'Manual' &&
          <div className='mt-3 p-3 yellow-background'>
            Manually created by: <strong>{_.get(props, 'userprofile.memberFullName', '')}</strong> on <strong>{moment(props.property.timestampEntered).format('MM/DD/YY')}</strong>
          </div>
        }

      </div>
    </React.Fragment>
  );
};
export default PropertyInfo;
